﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";

export interface IFormController {
    scope: IFormScope;
}

export interface IFormScope extends ng.IScope {
    modelType: string;
    validation: any;
    ngDisabled: boolean;
}

@NgComponent({
    token: Token.KbForm,
    dependencies: [
    ]
})
export class KbForm extends Directive {
    constructor() {
        super();

        this.replace = true;
        this.template = Dirs.component("kb-form");
        this.restrict = "E";
        this.scope = {
            modelType: "@",
            validation: "=",
            ngDisabled: "=?"
        };
        this.transclude = true;

        this.controller = ["$scope", "$element", function($scope: IFormScope, $element) {
            this.scope = $scope;
        }];
    }
}
